<template>
  <div class="pd-embed-control clone-default-users" :class="{ 'pd-embed-control-disabled': !canEdit }">
    <div
      class="clone-default-users-trigger pd-embed-value"
      :class="{
        'pd-embed-control-editable': canEdit,
        'pd-embed-empty-value': configuredCount === 0,
      }"
      @click="open"
    >
      <span v-if="!hasClonedBy">请先选择克隆对象</span>
      <span v-else-if="candidates.length === 0">无可配置选项</span>
      <span v-else>已配置 {{ configuredCount }}/{{ candidates.length }}</span>
      <BaseIcon icon="ios-arrow-down" color="var(--subtext2)" style="margin-left:5px;flex-shrink:0;" :size="13" />
    </div>

    <Modal
      v-model="modalOpen"
      title="按克隆选项配置默认审批人"
      :width="560"
      footer-hide
    >
      <div class="clone-default-users-modal">
        <div v-if="!hasClonedBy" class="clone-default-users-warn">请先在「克隆对象」中选择字段</div>
        <div v-else-if="candidates.length === 0" class="clone-default-users-warn">
          当前克隆字段没有可枚举选项（请确认字段选项或部门数据已加载）
        </div>
        <div v-else class="clone-default-users-list">
          <div
            v-for="item in candidates"
            :key="item.key"
            class="clone-default-users-row"
          >
            <div class="clone-default-users-label" :title="item.name">{{ item.name }}</div>
            <div class="clone-default-users-picker">
              <BaseUserSelectGrouped
                :value="draftMap[item.key]"
                :option="{ multiple: true }"
                editable
                @input="setDraft(item.key, $event)"
              />
            </div>
          </div>
        </div>
        <div class="clone-default-users-footer flex-wrap flex-right">
          <Button size="small" style="margin-right:8px;" @click="modalOpen = false">取消</Button>
          <Button type="primary" size="small" :disabled="!hasClonedBy" @click="confirm">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {listCloneOptionCandidates} from '@/components/flow/clone-display';

export default {
  name: 'PeCloneDefaultUsers',
  props: {
    value: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    db: {
      type: Object,
      default: () => ({}),
    },
    env: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalOpen: false,
      draftMap: {},
    };
  },
  computed: {
    ...mapGetters('session', ['deps', 'users']),
    canEdit() {
      return this.editable && this.hasClonedBy;
    },
    hasClonedBy() {
      const cb = this.db && this.db.clonedBy;
      if (!cb) return false;
      if (typeof cb === 'string') return !!cb;
      return !!(cb.key);
    },
    candidates() {
      if (!this.hasClonedBy) return [];
      return listCloneOptionCandidates(
        this.db.clonedBy,
        this.db.clonedType,
        {deps: this.deps || [], users: this.users || []},
      );
    },
    configuredCount() {
      const map = this.value && typeof this.value === 'object' ? this.value : {};
      return this.candidates.filter((c) => {
        const v = map[c.key];
        if (Array.isArray(v)) return v.length > 0;
        return v != null && v !== '';
      }).length;
    },
  },
  methods: {
    open() {
      if (!this.editable) return;
      if (!this.hasClonedBy) return;
      const src = this.value && typeof this.value === 'object' ? this.value : {};
      const draft = {};
      this.candidates.forEach((c) => {
        draft[c.key] = src[c.key] != null ? src[c.key] : null;
      });
      this.draftMap = draft;
      this.modalOpen = true;
    },
    setDraft(key, val) {
      this.$set(this.draftMap, key, val);
    },
    confirm() {
      const out = {};
      Object.keys(this.draftMap || {}).forEach((k) => {
        const v = this.draftMap[k];
        if (v == null || v === '') return;
        if (Array.isArray(v) && v.length === 0) return;
        // 统一用字符串 key，避免与表单部门 id 类型不一致
        out[String(k)] = Array.isArray(v) ? v.map(String) : v;
      });
      this.$emit('input', out);
      this.modalOpen = false;
    },
  },
};
</script>

<style lang="less">
.clone-default-users {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.clone-default-users-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 8px;
  cursor: pointer;
}
.pd-embed-control-disabled .clone-default-users-trigger {
  cursor: not-allowed;
  opacity: 0.65;
}
.clone-default-users-modal {
  padding: 4px 4px 8px;
  min-height: 240px;
}
.clone-default-users-warn {
  padding: 24px 12px;
  text-align: center;
  color: var(--subtext2);
  font-size: 13px;
}
.clone-default-users-list {
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 6px;
}
.clone-default-users-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
  &:last-child { border-bottom: none; }
}
.clone-default-users-label {
  width: 120px;
  flex-shrink: 0;
  font-size: 12px;
  color: var(--text2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.clone-default-users-picker {
  flex: 1;
  min-width: 0;
}
.clone-default-users-footer {
  margin-top: 12px;
}
</style>
